import {type ClusterUiConfig} from '../../../../shared/yt-types';

export const defaultClusterUiConfig: Partial<ClusterUiConfig> = {};
